export default {

    title: "Chargement...",

    responses: {
        "404": {
            title: "Une erreur s'est produite",
            header: "Une erreur s'est produite",
            message: "Jeton valide introuvable. Votre jeton a peut-être expiré."
        },
        "200_tfalogin": {
            title: "Vérification de connexion",
            header: "@:views.tunnel.service.response.200_tfalogin.title",
            message: "Connexion vérifiée."
        },
        "404_tfalogin": {
            title: "Vérification de connexion",
            header: "@:views.tunnel.service.response.404_tfalogin.title",
            message: "Jeton valide introuvable. Votre jeton a peut-être expiré."
        },
        "200_tfaaddress": {
            title: "Vérification d'adresse",
            header: "@:views.tunnel.service.responses.200_tfaaddress.title",
            message: "Merci d'avoir vérifié votre adresse. Vous pouvez désormais la sélectionner comme adresse de livraison lors de votre commande."
        },
        "404_tfaaddress": {
            title: "Vérification d'adresse",
            header: "@:views.tunnel.service.response.404_tfaaddress.title",
            message: "Jeton valide introuvable. Votre jeton a peut-être expiré."
        },
        "201_delivery": {
            title: "Merci",
            header: "Merci",
            message: "Merci pour votre réponse."
        },
        "201_shipment_received": {
            title: "Merci",
            header: "Merci",
            message: "Merci pour votre réponse."
        },
        "400": {
            title: "Requête incorrecte. Une erreur s'est produite.",
            header: "@:views.tunnel.service.response.400.title",
            message: "Requête incorrecte. Une erreur s'est produite."
        }
    }
}